<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang;
</script>

<div class="footer">
    <div class="footer__textbox">
        <div class="navbar__icons">
            <a
                href="https://mindlab.pl/"
                target="blank"
                class="social social--home"
            />
            <a
                href="https://pl-pl.facebook.com/mindlabcompany/"
                target="blank"
                class="social social--facebook"
            />
            <a
                href="https://www.instagram.com/_mindlab"
                target="blank"
                class="social social--instagram"
            />
            <a
                href="https://pl.linkedin.com/company/mindlab-sp-z-o-o-"
                target="blank"
                class="social social--linkedin"
            />
            <a
                href="https://www.youtube.com/user/MindLabPL"
                target="blank"
                class="social social--youtube"
            />
        </div>
        <div class="footer__social">
            <h4>{texts[lang].find_us}</h4>
            <a href="kontakt">Limanowskiego 31/15</a>
            <a href="mailto:biuro@mindlab.pl">biuro@mindlab.pl</a>
            <a href="tel:12 292 75 83">12 292 75 83</a>
        </div>
    </div>
</div>
